import { Checkbox } from '@sketchnote/shared-components';
import { setNodes, TElement, TTodoListItemElement, useEditorRef } from '@udecode/plate';
import cn from 'classnames';
import * as React from 'react';
import { ReactEditor, useReadOnly } from 'slate-react';

import { TodoListElementProps } from './TodoListElement.types';

export const TodoListElement = (props: TodoListElementProps) => {
  const { attributes, children, element } = props;

  const editor = useEditorRef();
  const readOnly = useReadOnly();

  const { checked } = element;

  const handleOnChange = (value: boolean) => {
    const path = ReactEditor.findPath(editor, element);

    setNodes<TElement & TTodoListItemElement>(
      editor,
      { checked: value },
      {
        at: path,
      }
    );
  };

  return (
    <div
      {...attributes}
      data-node="todo-list-element"
      className={cn('relative pl-30 py-8', {
        'line-through text-gray-500': !!checked,
      })}
    >
      <span contentEditable={!readOnly} suppressContentEditableWarning>
        {children}
      </span>
      <div contentEditable={false} className="absolute top-14 left-0">
        <Checkbox
          checked={!!checked}
          size="small"
          color="#2BC545"
          variant="white"
          onChange={handleOnChange}
        />
      </div>
    </div>
  );
};
